(function($) {

	'use strict';

	var init = function() {

		burgerMenu();
		toggleSubMenu();

	};

	var burgerMenu = function() {

		var top = 0;

		$('.header__burger').click(function() {
			$('.header__swipe').addClass('active');	
			top = $(window).scrollTop();
			$('body').addClass('open');
			$('body').scrollTop(top);
		});

		$('.header__swipe__close').click(function() {
			$('.header__swipe').removeClass('active');
			$('body').removeClass('open');
			$('html, body').scrollTop(top);
		});
	}

	var toggleSubMenu = function() {
		$('.header__nav .menu-item-has-children').each(function() {
			$(this).append('<button class="sub-menu-toggler"></button>')
		});
		$('.sub-menu-toggler').each(function() {
			$(this).click(function() {
				$(this).toggleClass('active');
				$(this).parent().find('.sub-menu').toggleClass('active');
				$(this).parent().toggleClass('active');
			});
		});
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
